import { Component, Inject, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Base } from '../../base';
import { DetallesBeneficiosAnexos } from '../../../../models/poblacion/mi-poblacion';

@Component({
  selector: 'app-dialog-poblacion-detalle-anexos',
  templateUrl: './dialog-poblacion-detalle-anexos.component.html',
  styleUrls: ['./dialog-poblacion-detalle-anexos.component.css']
})
export class DialogPoblacionDetalleAnexosComponent extends Base {

  @ViewChild('cellphoneInput') cellphoneInput!: ElementRef;
  @ViewChild('emailInput') emailInput!: ElementRef;
  @Output() generateEvent = new EventEmitter<number>();
  dataDetail!: DetallesBeneficiosAnexos[];
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogPoblacionDetalleAnexosComponent>,    
  ) {
    super();    
    this.dataDetail = data;
  }

  close(){
    this.dialogRef.close();
  }
}
